module.exports = __webpack_public_path__ + "img/color-balance_en.5622e68.jpg";